import HandMatchTabContainer from './HandMatchTabContainer';

export default HandMatchTabContainer;
